import logo from './logo.svg';
import './App.css';
import Navbar from './Navbar/Navbar'



function App() {
  return (
    <div className="App">
      <Navbar />
    </div>  
  );
}

export default App;


